export enum CalendarView {
  DAY,
  WEEK,
}
